export default "__VITE_ASSET__CcKbYUGI__"